<template>
    <div class="chapterSetUp">
        <div class="content_warp padding-20 bgc box-shadow">
            <!-- <el-alert style="padding: 12px 16px;" title=" 请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，鲸客通保有依据国家规定及平台规则进行处理的权利。" type="warning" show-icon :closable="false"></el-alert> -->
            <el-alert title=" 请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。" type="warning" show-icon :closable="false"></el-alert>
            <p class="title_text">章节设置</p>
            <transition-group tag="div" class="chapter_container">
                <div class="chapter_item_content" v-for="(item, index) in items" :key="index" :draggable="isDrag"
                    @dragstart="handleDragStart($event, item)"
                    @dragover.prevent="handleDragOver($event, item)"
                    @dragenter="handleDragEnter($event, item)"
                    @dragend="handleDragEnd($event, item)"
                    @dragleave="handleDragleave($event, item, index)">

                    <div @click="isShowCourse(index)" class="chapter_title_box" :chapterIndex="index">
                        <div class="chapter_item_left_box" :class="`input_${index + 1}`">
                            <i class="arrows_icon" :class="item.showContent ? 'is-active' : 'no-active'"></i>
                            <!-- <span style="display: inline-block; width: 30px;">{{index+1}}.&nbsp;</span> -->
                            <span v-show="!item.titleEdit">{{item.sectionname}}</span>
                            <!-- <el-input v-show="item.titleEdit" @blur="inputBlur(index)" :class="item.sectionname === '' && item.addChapterStatus !== 1 ? 'input_tips' : ''" @click.stop.native="stopstop($event)" style="width: 400px;" v-model="item.sectionname" placeholder="输入章节名称，30个字以内" maxlength="30" show-word-limit></el-input> -->
                            <el-input v-show="item.titleEdit" @blur="inputBlur(index)" :class="item.sectionname === '' ? 'input_tips' : ''" @click.stop.native="stopstop($event)" style="width: 400px;" v-model="item.sectionname" placeholder="输入每章名称，30个字以内" maxlength="30" show-word-limit></el-input>
                            <label v-if="item.titleEditTips" style="color: #FB6161; margin-left: 10px;">* 每章名称不能为空</label>
                        </div>
                        <div class="chapter_item_right_box">
                            <p class="tips_text">共{{item.taskinfolist.length}}节</p>
                            <div>
                                <i title="拖拽" @click="handleIconClick('icon_drag', index, $event)" class="handle_icon" @mouseover="mouseOver" @mouseleave="mouseLeave"></i>
                                <i title="编辑" @click="handleIconClick('icon_edit', index, $event)" class="handle_icon"></i>
                                <i title="删除" @click="handleIconClick('icon_del', index, $event)" class="handle_icon"></i>
                            </div>
                        </div>
                    </div>
                    <div v-show="item.showContent" class="chapter_task_content_box">
                        <div v-for="(subItem, subindex) in item.taskinfolist" :key="subindex" class="chapter_task_item_box" :draggable="itemIsDrag"
                            @dragstart="handleItemDragStart($event, subItem, index, subindex)"
                            @dragover.prevent="handleItemDragOver($event, subItem)"
                            @dragenter="handleItemDragEnter($event, subItem, index, subindex)"
                            @dragend="handleItemDragEnd($event, subItem)"
                            @dragleave="handleItemDragleave($event, subItem)">

                            <div v-show="!subItem.taskEdit" @click="isShowCourseItem(index, subindex)">
                                <div class="chapter_item_left_box">
                                    <i class="arrows_icon" v-show="subItem.childrenlist && subItem.childrenlist.length" :class="subItem.showContent ? 'is-active' : 'no-active'"></i>
                                    <span :class="{'tackname': !subItem.childrenlist || !subItem.childrenlist.length}">{{subItem.taskname}}</span>
                                </div>
                                <div>
                                    <i @click.stop="taskHandleClick('icon_add', index, subindex)" v-show="!false" title="增加下级" class="handle_icon"></i>
                                    <i @click.stop="taskHandleClick('icon_drag', index, subindex)" v-show="!false" title="拖拽" class="handle_icon" @mouseover="itemMouseOver" @mouseleave="itemMouseLeave"></i>
                                    <i @click.stop="taskHandleClick('icon_edit', index, subindex)" v-show="!false" title="编辑" class="handle_icon"></i>
                                    <i @click.stop="taskHandleClick('icon_del', index, subindex)" title="删除" class="handle_icon"></i>
                                </div>
                            </div>
                            <div v-show="subItem.taskEdit">
                                <div :class="`inputItem_${index}_${subindex}`">
                                    <label class="label_text">每节名称</label>
                                    <el-input @focus="itemInputfocus(subItem)" :class="subItem.taskname === '' ? 'showTips' : ''" style="width: 530px;" v-model="subItem.taskname" placeholder="输入每节名称，45个字以内" maxlength="45" show-word-limit></el-input>
                                    <label v-if="subItem.taskname === ''" style="color: #FB6161; margin-left: 10px;">* 每节名称不能为空</label>
                                </div>
                                <div>
                                    <label class="label_text">对应试卷</label>
                                    <div class="goods_info_box">
                                        <img :src="subItem.epcoverurl" alt="">
                                        <p>{{subItem.exampapername}}</p>
                                        <div>
                                            <el-button class="select" @click="anewSelect(index, subindex)">{{subItem.objectid ? '重新选择' : '选择'}}</el-button>
                                            <el-button class="delete" @click="anewDlete(index, subindex)">删除</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="subItem.showContent" class="chapter_task_item_box_content_box">
                                <div v-for="(subItemItem, subItemIndex) in subItem.childrenlist" :key="subItemIndex" class="chapter_task_item_box_item_box" :draggable="itemItemIsDrag"
                                    @dragstart="handleItemItemDragStart($event, subItemItem, index, subindex, subItemIndex)"
                                    @dragover.prevent="handleItemItemDragOver($event, subItemItem)"
                                    @dragenter="handleItemItemDragEnter($event, subItemItem, index, subindex, subItemIndex)"
                                    @dragend="handleItemItemDragEnd($event, subItemItem)"
                                    @dragleave="handleItemItemDragleave($event, subItemItem)">
                                    <div v-show="!subItemItem.taskEdit" @click="hideTaskItem(index, subindex, subItemIndex)" class="chapter_task_item_box_content_box_item">
                                        <div class="taskname">{{subItemItem.taskname}}</div>
                                        <div class="icon_box">
                                            <i @click.stop="taskItemHandleClick('icon_drag', index, subindex, subItemIndex)" v-show="!false" title="拖拽" class="handle_icon" @mouseover="itemItemMouseOver" @mouseleave="itemItemMouseLeave"></i>
                                            <i @click.stop="taskItemHandleClick('icon_edit', index, subindex, subItemIndex)" v-show="!false" title="编辑" class="handle_icon"></i>
                                            <i @click.stop="taskItemHandleClick('icon_del', index, subindex, subItemIndex)" title="删除" class="handle_icon"></i>
                                        </div>
                                    </div>
                                    <div v-show="subItemItem.taskEdit" class="taskEdit">
                                        <div class="taskEdit_item_name" :id="`inputItem_${index}_${subindex}_${subItemIndex}`">
                                            <label class="label_text">节点名称</label>
                                            <el-input @focus="itemItemInputfocus(subItemItem, index, subindex, subItemIndex)" :class="subItemItem.taskname === '' ? 'showTips' : ''" style="width: 530px;" v-model="subItemItem.taskname" placeholder="输入每节名称，45个字以内" maxlength="45" show-word-limit></el-input>
                                            <label v-if="subItemItem.taskname === ''" style="color: #FB6161; margin-left: 10px;">* 节点名称不能为空</label>
                                        </div>
                                        <div class="test_paper">
                                            <label class="label_text">对应试卷</label>
                                            <div class="goods_info_box">
                                                <img :src="subItemItem.epcoverurl" alt="">
                                                <p>{{subItemItem.exampapername}}</p>
                                                <el-button class="select" @click="anewItemSelect(index, subindex, subItemIndex)">{{subItemItem.objectid ? '重新选择' : '选择'}}</el-button>
                                                <el-button class="delete" @click="anewItemDlete(index, subindex, subItemIndex)">删除</el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add_chapter_box">
                            <span @click="addStudyTask(index)">+ 添加一节</span>
                        </div>
                    </div>
                </div>
            </transition-group>
            <div class="chapter_item add_chapter_box">
                <span @click="addCurriculum()">+ 新增一章</span>
            </div>
        </div>
        <div class="submit_box padding-20 bgc box-shadow">
            <el-button @click="cancelBtn()">取消</el-button>
            <el-button @click="ensureBtn()" type="primary">确定</el-button>
        </div>
        <shop2 ref="shop2" @setShop="setShopList"></shop2>
        <shop3 ref="shop3" @setShop="setShopItem"></shop3>
        <shop3 ref="shop4" @setShop="setItemShopItem"></shop3>
    </div>
</template>

<script>
import Shop2 from './components/shop2'
import Shop3 from './components/shop3'
import {getQuestionSectionDetail, saveOrUpdateQuestionSection} from 'api/questionApi'
import {mapGetters, mapActions} from 'vuex'
export default {
 name: 'ChapterSetUp',
    data() {
        return {
            items: [],
            dragging: null,
            isDrag: false,
            itemDragging: null,
            itemIsDrag: false,
            indexes: null,
            taskIndexes: null,
            lastItem: null, // 章节设置上一选择
            index: null,    // 章节下标
            itemIndex: null,    // 学习任务下标
            itemItemIsDrag: true,
            itemItemDragging: null
        }
    },
    mounted() {
        this.findQuestionSectionDetail()
    },
    methods: {
        // 获取课程章节设置详情
        findQuestionSectionDetail() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.qid
            }
            getQuestionSectionDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log('data:', data.data.content)
                    this.items = data.data.content
                    for (let index = 0; index < this.items.length; index++) {
                        if (this.items[index].titleEdit === 'true') {
                            this.items[index].titleEdit = true
                        } else {
                            this.items[index].titleEdit = false
                        }
                        if (this.items[index].titleEditTips === 'true') {
                            this.items[index].titleEditTips = true
                        } else {
                            this.items[index].titleEditTips = false
                        }
                        if (this.items[index].showContent === 'true') {
                            this.items[index].showContent = true
                        } else {
                            this.items[index].showContent = false
                        }
                        for (let j = 0; j < this.items[index].taskinfolist.length; j++) {
                            this.$set(this.items[index].taskinfolist[j], 'taskEdit', false)
                            this.$set(this.items[index].taskinfolist[j], 'showContent', false)
                            for (let m = 0; m < this.items[index].taskinfolist[j].childrenlist.length; m++) {
                                this.$set(this.items[index].taskinfolist[j].childrenlist[m], 'taskEdit', false)
                            }
                        }
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        itemItemInputfocus(subItemItem, index, subindex, subItemIndex) {
            this.itemDataPositon(subItemItem)
            // subItemItem.taskEdit = true
        },
        isShowCourseItem(index, subindex) {
            let obj = this.items[index].taskinfolist[subindex]
            obj.showContent = !this.items[index].taskinfolist[subindex].showContent
            this.$set(this.items[index].taskinfolist, subindex, obj)
            if (!this.items[index].taskinfolist[subindex].showContent) {
                if (this.items[index].taskinfolist[subindex].childrenlist) {
                    this.items[index].taskinfolist[subindex].childrenlist.forEach((obj, index) => {
                        obj.taskEdit = false
                    })
                }
            } else {
                if (this.items[index].taskinfolist[subindex].childrenlist) {
                    this.items[index].taskinfolist[subindex].childrenlist.forEach((obj, index) => {
                        if (obj.taskname) {
                            obj.taskEdit = false
                        } else {
                            obj.taskEdit = true
                        }
                    })
                }
            }
        },
        // 章节名称input框  失焦验证
        inputBlur(i) {
            // console.log(i)
            // i : 当前input框对应的索引
            // input框失去焦点  不再显示input  显示标题文本
            if (this.items[i].sectionname === '') {
                this.items[i].titleEditTips = true
                this.items[i].showContent = false
                this.items[i].addChapterStatus = 1
                this.$nextTick(() => {
                    // $(`.input_${i+1} input`).css('border','1px solid #FB6161')
                    // $(`.input_${i+1} input`).css('border-color','#FB6161')
                    $(`.input_${i+1} div`).addClass('input_tips')
                })
            } else {
                this.items[i].titleEdit = false
                this.items[i].titleEditTips = false
                this.$nextTick(() => {
                    // $(`.input_${i+1} input`).css('border','1px solid #409EFF')
                    // $(`.input_${i+1} input`).css('border-color','2FCE6F')
                    $(`.input_${i+1} div`).removeClass('input_tips')
                })
                if (this.items[i].addChapterStatus === 1) {
                    this.items[i].showContent = true
                    this.items[i].addChapterStatus = 0
                }
            }
        },
        // input框点击阻止触发父级div上课程展开、收起的方法
        stopstop(event) {
            // console.log(event)
            // 阻止事件冒泡  点击操作图标阻止当前课程展开收起功能
            event.stopPropagation()
        },
        // 课程展开 、 收起
        isShowCourse(i) {

            // 关闭学习任务
            this.closeItem()

            // 关闭其它展开的课程
            for (let j = 0; j < this.items.length; j++) {
                if (i === j) {
                    this.items[i].showContent = !this.items[i].showContent
                } else {
                    this.items[j].showContent = false
                }
            }

            // console.log(i)
            // if (this.items[i].titleEditTips === true) {
                
            // } else {
            //     this.items[i].showContent = !this.items[i].showContent
            // }
        },
        // 取得焦点
        itemInputfocus(subItem) {
            // console.log('取得', subItem)
            this.itemDataPositon(subItem)
        },
        // 章节操作图标点击事件
        handleIconClick(name, i, event) {
            // console.log(i)
            // console.log(event)

            // 关闭学习任务
            this.closeItem()

            if (name === 'icon_edit') {
                // console.log(`编辑课程标题--索引${i}`)
                this.items[i].titleEdit = true
                this.$nextTick(() => {
                    $(`.input_${i+1} input`).focus()
                })
            } else if (name === 'icon_del') {
                // console.log(`删除课程--索引${i}`)
                this.items.splice(i, 1)
            }
            // 阻止事件冒泡  点击操作图标阻止当前课程展开收起功能
            event.stopPropagation()
        },
        // 添加学习任务
        addStudyTask(i) {
            this.indexes = i
            let obj = {
                objectid: '',
                epcoverurl: '',
                innerid: '',
                taskEdit: true,
                exampaperid: '',
                exampaperinnerid: '',
                exampapername: '',
                taskname: '',
                taskinfolist: []
            }
            this.itemDataPositon()
            this.items[this.indexes].taskinfolist.push(obj)
            // this.$refs.shop2.openDialog([])
        },
        // 内容列表获取 ---- 确定添加学习任务
        setShopList(datalist) {

            console.log(datalist)
            this.items[this.indexes].taskinfolist = this.items[this.indexes].taskinfolist.concat(datalist)

            // 关闭其它编辑


            // 展开新增学习编辑
            let chapterIndex = this.items[this.indexes].taskinfolist.length - datalist.length,
                taskIndex = this.indexes

            this.$nextTick(() => {
               this.taskHandleClick('icon_edit', taskIndex, chapterIndex)
            })
        },
        // 学习任务操作图标  ----  编辑、删除、拖拽
        taskHandleClick(name, chapterIndex, taskIndex) {

            // 关闭学习任务
            this.closeItem()

            if (name === 'icon_edit') {
                // console.log('编辑任务图标') 
                // console.log('章节索引：', chapterIndex)
                // console.log('章节任务索引：', taskIndex)

                // 存储本次的学习任务
                this.lastItem = this.items[chapterIndex].taskinfolist[taskIndex]
                this.items[chapterIndex].taskinfolist[taskIndex].taskEdit = true

                // input焦点出发
                this.$nextTick(() => {
                    $(`.inputItem_${chapterIndex}_${taskIndex} input`).focus()
                })

                // console.log("inputItem_"+chapterIndex+"_"+taskIndex)
                // console.log('我是编辑')

            } else if (name === 'icon_del') {
                // console.log(`删除课程--索引${i}`)
                this.items[chapterIndex].taskinfolist.splice(taskIndex, 1)
            } else if (name === 'icon_add') {
                let obj = {
                    objectid: '',
                    epcoverurl: '',
                    innerid: '',
                    taskEdit: true,
                    exampaperid: '',
                    exampaperinnerid: '',
                    exampapername: '',
                    taskname: '',
                    showContent: true
                }
                console.log(this.items[chapterIndex].taskinfolist[taskIndex])
                let item = this.items[chapterIndex].taskinfolist[taskIndex]
                item.showContent = true
                this.$set(this.items[chapterIndex].taskinfolist, taskIndex, item)
                if (this.items[chapterIndex].taskinfolist[taskIndex].childrenlist) {
                    this.items[chapterIndex].taskinfolist[taskIndex].childrenlist.push(obj)
                } else {
                    this.$set(this.items[chapterIndex].taskinfolist[taskIndex], 'childrenlist', [obj])
                }
                this.$nextTick(() => {
                    $(`#inputItem_${chapterIndex}_${taskIndex}_${this.items[chapterIndex].taskinfolist[taskIndex].childrenlist.length - 1} input`).focus()
                })
            }
        },
        taskItemHandleClick(name, chapterIndex, taskIndex, subItemIndex) {
            // 关闭学习任务
            this.closeItem()
            if (name === 'icon_edit') {
                this.items[chapterIndex].taskinfolist[taskIndex].childrenlist.forEach((obj, index) => {
                    if (obj.taskname && index !== subItemIndex) {
                        obj.taskEdit = false
                    }
                    console.log('895')
                })
                let obj = this.items[chapterIndex].taskinfolist[taskIndex].childrenlist[subItemIndex]
                obj.taskEdit = true
                this.$set(this.items[chapterIndex].taskinfolist[taskIndex].childrenlist, subItemIndex, obj)
            } else if (name === 'icon_del') {
                this.items[chapterIndex].taskinfolist[taskIndex].childrenlist.splice(subItemIndex, 1)
            }
        },
        // 重新选择任务商品
        anewSelect(chapterIndex, taskIndex) {
            // console.log(chapterIndex)
            // console.log(taskIndex)
            this.indexes = chapterIndex
            this.taskIndexes = taskIndex
            this.$refs.shop3.openDialog([])
        },
        // 第三季选择任务商品
        anewItemSelect(chapterIndex, taskIndex, subItemIndex) {
            this.indexes = chapterIndex
            this.taskIndexes = taskIndex
            this.itemIndex = subItemIndex
            this.$refs.shop4.openDialog([])
        },
        // 确定重新设置任务商品
        setShopItem(datalist) {
            // console.log('确定重新设置任务商品:', datalist)
            this.items[this.indexes].taskinfolist[this.taskIndexes].objectid = datalist[0].objectid
            this.items[this.indexes].taskinfolist[this.taskIndexes].epcoverurl = datalist[0].epcoverurl
            console.log(this.items[this.indexes].taskinfolist[this.taskIndexes])
            if (!this.items[this.indexes].taskinfolist[this.taskIndexes].innerid) {
                this.items[this.indexes].taskinfolist[this.taskIndexes].innerid = datalist[0].innerid
            }
            console.log(this.items[this.indexes].taskinfolist[this.taskIndexes])
            this.items[this.indexes].taskinfolist[this.taskIndexes].taskEdit = datalist[0].taskEdit
            this.items[this.indexes].taskinfolist[this.taskIndexes].exampaperid = datalist[0].exampaperid
            this.items[this.indexes].taskinfolist[this.taskIndexes].exampaperinnerid = datalist[0].exampaperinnerid
            this.items[this.indexes].taskinfolist[this.taskIndexes].exampapername = datalist[0].exampapername
            if (!this.items[this.indexes].taskinfolist[this.taskIndexes].taskname) {
                this.items[this.indexes].taskinfolist[this.taskIndexes].taskname = datalist[0].taskname
            }
        },
        // 第三级确定设置任务商品
        setItemShopItem(datalist) {
            this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].objectid = datalist[0].objectid
            this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].epcoverurl = datalist[0].epcoverurl
            if (!this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].innerid) {
                this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].innerid = datalist[0].innerid
            }
            this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].taskEdit = datalist[0].taskEdit
            this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].exampaperid = datalist[0].exampaperid
            this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].exampaperinnerid = datalist[0].exampaperinnerid
            this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].exampapername = datalist[0].exampapername
            if (!this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].taskname) {
                this.items[this.indexes].taskinfolist[this.taskIndexes].childrenlist[this.itemIndex].taskname = datalist[0].taskname
            }
            console.log(datalist)
        },
        // 新增章节
        addCurriculum() {
            this.items.push({innerid: '', sectionname: '', titleEdit: true, titleEditTips: false, showContent: false, addChapterStatus: 1, taskinfolist: []})
            this.$nextTick(() => {
                $(`.input_${this.items.length} input`).focus()
            })
        },

        // 拖拽图标鼠标移入
        mouseOver () {
            this.isDrag = true
        },
        // 拖拽图标鼠标移出
        mouseLeave () {
            this.isDrag = false
        },
        // 拖拽图标鼠标移入
        itemMouseOver() {
            this.itemIsDrag = true
        },
        // 拖拽图标鼠标移出
        itemMouseLeave() {
            this.itemIsDrag = false
        },
        itemItemMouseOver() {
            this.itemItemIsDrag = true
        },
        itemItemMouseLeave() {
            this.itemItemIsDrag = false
        },
        handleDragStart(even, item){
            
            // console.log(even)
            // even.target.firstChild.style.opacity = 1
            // even.target.firstChild.style.background = 'linear-gradient: none'
        //    even.target.style.display = 'none'

            // even.target.style.background = "#ff00cc"

            this.dragging = item
        },
        handleDragEnd(e,item){
            this.dragging = null
        },
        //首先把div变成可以放置的元素，即重写dragenter/dragover
        handleDragOver(e) {
            e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
        },
        handleDragEnter(e, item){
            if (this.isDrag) {
                // console.log('e:', e)
                // console.log('item:', item)
                // console.log('this.dragging:', this.dragging)

                // 进行高亮
                // console.log(e.target.className)

                if (e.target.className == "chapter_title_box") {
                    e.target.style.background = "#EAEEF4"
                    // console.log('handleDragEnter purple')
                }

                
                e.dataTransfer.effectAllowed = 'move'//为需要移动的元素设置dragstart事件
                // console.log(e.dataTransfer.effectAllowed);
                
                if(item === this.dragging){
                    return
                }
                const newItems = [...this.items]
                // console.log(newItems)
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
                this.items = newItems
            }
        },
        handleDragleave(e, item, index) { // 当拖动元素离开可放置目标节点，重置其背景

            console.log('handleDragleave purple')

            if (item.taskinfolist.length == 0) {
                // console.log(item)
                this.handleItemDragEnter(e, item, index, 0)
            }
        
            // if (event.target.className == "chapter_title_box" ) {
            //     event.target.style.background = "";
            // }
        },

        // 学习
        handleItemDragStart(e,item, index, subindex){

            // 选中的学习任务
            this.itemDragging = item

            // 记录选中的学习任务 父章节下标
            this.index = index

            // 纪录选中学习任务下标
            this.itemIndex = subindex

            // 高光
            if (e) {

            }

        },
        // 学习
        handleItemItemDragStart(e,item, index, subindex, subItemIndex){
            console.log('1')
            // 选中的学习任务
            this.itemItemDragging = item

            // 记录选中的学习任务 父章节下标
            this.index = index

            // 纪录选中学习任务下标
            this.itemIndex = subindex

            // 记录第三级人物下标
            this.subItemIndex = subItemIndex
            // 高光
            if (e) {

            }

        },
        handleItemDragEnd(e,item){
            this.itemDragging = null
        },
        handleItemItemDragEnd(e,item){
            console.log(4)
            this.itemIndex = null
        },
        //首先把div变成可以放置的元素，即重写dragenter/dragover
        handleItemDragOver(e) {
            e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
        },
        //首先把div变成可以放置的元素，即重写dragenter/dragover
        handleItemItemDragOver(e) {
            console.log(2)
            e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
        },
        handleItemDragEnter(e, item, index, subindex){
            // console.log('itemIsDrag',this.itemIsDrag)
            if (this.itemIsDrag) {

                // 进行高亮
                // console.log(e.target.className)
                // if (e.target.className == "chapter_title_box") {
                //     e.target.style.background = "#EAEEF4"
                //     console.log('handleDragEnter purple')
                // }

                e.dataTransfer.effectAllowed = 'move'//为需要移动的元素设置dragstart事件
                
                if(item === this.itemDragging){
                    return
                }

                const newItems = [...this.items]

                const src = newItems[index].taskinfolist.indexOf(this.itemDragging)
                

                // console.log('拖动到的章节下标 index----------->'+ index)
                console.log('拖动学习任务 this.itemDragging -->' + this.itemDragging)

                // console.log(this.itemDragging)
                
                // 判断是否在原章节内进行移动，是则自行移动，否则替换章节

                console.log('点击元素下标'+this.index+'-->当前所处移动的下标'+index)

                if (this.index === index) {
                    newItems[index].taskinfolist.splice(subindex, 0, ...newItems[index].taskinfolist.splice(src, 1))
                } else {

                    // 更换章节时 删除原章节 index 下的元素 添加新章节内容

                    // 添加新章节内容
                    newItems[index].taskinfolist.splice(subindex, 0, ...newItems[this.index].taskinfolist.splice(this.itemIndex, 1))

                    // 记录替换后元素的新下标

                    // 记录选中的学习任务 父章节下标
                    this.index = index

                    // 纪录选中学习任务下标
                    this.itemIndex = subindex
                 
                }

                // 纪录选中学习任务下标
                this.itemIndex = subindex

                this.items = newItems
            }
        },
        anewDlete(index, subindex) {
            console.log(this.items[index].taskinfolist[subindex])
            this.items[index].taskinfolist[subindex].exampapername = ''
            this.items[index].taskinfolist[subindex].exampaperinnerid = ''
            this.items[index].taskinfolist[subindex].epcoverurl = ''
            this.items[index].taskinfolist[subindex].exampaperid = ''
            // this.items[index].taskinfolist.splice(subindex, 1)
        },
        anewItemDlete(index, subindex, subItemIndex) {
            this.items[index].taskinfolist[subindex].childrenlist[subItemIndex].exampapername = ''
            this.items[index].taskinfolist[subindex].childrenlist[subItemIndex].exampaperinnerid = ''
            this.items[index].taskinfolist[subindex].childrenlist[subItemIndex].epcoverurl = ''
            this.items[index].taskinfolist[subindex].childrenlist[subItemIndex].exampaperid = ''
            // this.items[index].taskinfolist[subindex].childrenlist.splice(subItemIndex, 1)
        },
        handleItemItemDragEnter(e, item, index, subindex, subItemIndex){
            console.log(3)
            // console.log('itemIsDrag',this.itemIsDrag)
            if (this.itemItemIsDrag) {

                // 进行高亮
                // console.log(e.target.className)
                // if (e.target.className == "chapter_title_box") {
                //     e.target.style.background = "#EAEEF4"
                //     console.log('handleDragEnter purple')
                // }

                e.dataTransfer.effectAllowed = 'move'//为需要移动的元素设置dragstart事件
                console.log(item.taskname, this.itemItemDragging.taskname, item === this.itemItemDragging)
                if(item === this.itemItemDragging){
                    return
                }

                const newItems = [...this.items]

                const src = newItems[index].taskinfolist[subindex].childrenlist.indexOf(this.itemItemDragging)
                console.log(src)

                // console.log('拖动到的章节下标 index----------->'+ index)
                console.log('拖动学习任务 this.itemDragging -->' + this.itemItemDragging)

                // console.log(this.itemDragging)
                
                // 判断是否在原章节内进行移动，是则自行移动，否则替换章节

                console.log('点击元素下标'+this.subItemIndex+'-->当前所处移动的下标'+subItemIndex)
                console.log(this.index, index)
                if (this.index === index) {
                    console.log('相同')
                    newItems[index].taskinfolist[subindex].childrenlist.splice(subItemIndex, 0, ...newItems[index].taskinfolist[subindex].childrenlist.splice(src, 1))
                } else {

                    // 更换章节时 删除原章节 index 下的元素 添加新章节内容

                    // 添加新章节内容
                    newItems[index].taskinfolist[subindex].childrenlist.splice(subItemIndex, 0, ...newItems[this.index].taskinfolist[subindex].childrenlist.splice(this.subItemIndex, 1))

                    // 记录替换后元素的新下标

                    // 记录选中的学习任务 父章节下标
                    this.index = index

                    // 纪录选中学习任务下标
                    this.itemIndex = subindex
                    // this.itemIndex = subItemIndex
                }

                // 纪录选中学习任务下标
                this.itemIndex = subindex

                this.items = newItems
                console.log(newItems)
            }
        },
        handleItemDragleave(e, item) { // 当拖动元素离开可放置目标节点，重置其背景
        
            // if (event.target.className == "chapter_title_box" ) {
            //     event.target.style.background = ""
            // }
        },

        handleItemItemDragleave(e, item) {
            console.log(5)
        },

        hideTaskItem (index, subindex, subItemIndex) {
            console.log(55)
            // let that = this
            this.items[index].taskinfolist[subindex].childrenlist.forEach((obj, index) => {
                if (obj.taskname) {
                    obj.taskEdit = false
                    // this.$set(this.items[index].taskinfolist[subindex].childrenlist, index, obj)
                }
            })
        },

        closeItem() {   // 关闭学习任务栏
            if (this.lastItem !== null ) {
                // 上一学习任务栏不为空时，进行关闭
                this.lastItem.taskEdit = false  
            }
            this.itemDataPositon()
            // }
        },
        itemDataPositon(item) { // 操作控制
            console.log('关闭')
            for (let i = 0; i < this.items.length; i++) {
                    // edit.taskEdit = true
                    for (let j = 0; j < this.items[i].taskinfolist.length; j++) {
                        if (this.items[i].taskinfolist[j].taskname === "") {
                            // this.$nextTick(() => {
                                this.items[i].taskinfolist[j].taskEdit = true
                            // })
                        } else {
                            if (this.items[i].taskinfolist[j].taskEdit === true) {
                                this.items[i].taskinfolist[j].taskEdit = false
                            }
                        }
                        if (!this.items[i].taskinfolist[j].childrenlist) {
                            this.$set(this.items[i].taskinfolist[j], 'childrenlist', [])
                        }
                        for (let m = 0; m < this.items[i].taskinfolist[j].childrenlist.length; m++) {
                            if (this.items[i].taskinfolist[j].childrenlist[m].taskname) {
                                this.items[i].taskinfolist[j].childrenlist[m].taskEdit = false
                            } else {
                                this.items[i].taskinfolist[j].childrenlist[m].taskEdit = true
                            }
                        }
                    }
            }
            if (item) {
                item.taskEdit = true
            }
            this.$nextTick(() => {
                this.items = this.items
            })
        },
        // 取消按钮
        cancelBtn() {
            // this.$message.error('取消按钮')
            // window.history.back()
            this.$router.push({name: 'SubjectList'})
        },
        // 确定按钮
        ensureBtn() {
            // this.$message.success('确定按钮')
            // console.log(JSON.stringify(this.items))
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].sectionname === '') {
                    this.$message.error('每章名称不能为空！')
                    return false
                }
                for (let j = 0; j < this.items[i].taskinfolist.length; j++) {
                    if (this.items[i].taskinfolist[j].taskname ==='') {
                        this.$message.error('每节名称不能为空！')
                        return false
                    }
                    if (!this.items[i].taskinfolist[j].childrenlist) {
                        this.$set(this.items[i].taskinfolist[j], 'childrenlist', [])
                    }
                    for (let m = 0; m < this.items[i].taskinfolist[j].childrenlist.length; m++) {
                        if (this.items[i].taskinfolist[j].childrenlist[m].taskname === '') {
                            this.$message.error('节点名称不能为空！')
                            return false
                        }
                    }
                }
            }
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.qid,
                sectioninfo: JSON.stringify(this.items)
            }
            saveOrUpdateQuestionSection({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // window.history.back()
                    this.$router.push({name: 'SubjectList'})
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Shop2,
        Shop3,
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .chapterSetUp {
        font-family:PingFangSC-Medium,PingFang SC;
        // width: 100%;
        // position: relative;
        .content_warp {
            // padding-bottom: 100px;
            min-height: 76vh;
            margin-bottom: 20px;
            .title_text {
                color: #303133;
                font-size: 16px;
                font-weight: bold;
                line-height: 20px;
                border-left: 2px solid #409EFF;
                padding-left: 10px;
                margin: 20px 0;
            }
            // .chapter_container{
                // background-color: rgb(0, 0, 0);
                // display:flex;
                // flex-direction: column;
                // padding: 0;
            // }
            .chapter_item_content {
                transition: all linear .3s;
                margin-top: 10px;
                .chapter_title_box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background-color: #F5F7FA;
                    cursor: pointer;
                    height: 56px;
                    padding: 0 30px;
                    .chapter_item_left_box {
                        display: flex;
                        align-items: center;
                        .arrows_icon {
                            display: inline-block;
                            background-image: url('../../../common/images/cms/fewer.png');
                            background-size: 100% 100%;
                            width: 14px;
                            height: 8px;
                            margin-right: 20px;
                            transition: transform .3s,
                            -webkit-transform .3s;
                        }
                        .arrows_icon.is-active {
                            -webkit-transform: rotate(-180deg);
                            transform: rotate(-180deg);
                        }
                        .input_tips {
                            input {
                                border-color: #FB6161!important;
                            }
                            input:focus {
                                border-color: #409eff!important;
                            }
                        }
                    }
                    .chapter_item_right_box {
                        .tips_text {
                            color: #909399;
                            display: block;
                        }
                        &>div {
                            display: flex;
                            .handle_icon {
                                background-image: url('../../../common/images/cms/drag.png');
                                background-size: 24px 24px;
                                width: 24px;
                                height: 24px;
                                cursor: pointer;
                                display: none;
                            }
                            .handle_icon:hover {
                                background-image: url('../../../common/images/cms/drag_hover.png');
                            }
                            .handle_icon:nth-of-type(2){
                                background-image: url('../../../common/images/cms/edit.png');
                            }
                            .handle_icon:nth-of-type(2):hover{
                                background-image: url('../../../common/images/cms/edit_hover.png');
                            }
                            .handle_icon:nth-of-type(3){
                                background-image: url('../../../common/images/cms/del.png');
                            }
                            .handle_icon:nth-of-type(3):hover{
                                background-image: url('../../../common/images/cms/del_hover.png');
                            }
                            .handle_icon+.handle_icon {
                                margin-left: 30px;
                            }
                        }
                    }
                }
                .chapter_title_box:hover{
                    background-color: #EAEEF4;
                    .chapter_item_right_box {
                        .tips_text {
                            display: none;
                        }
                        &>div {
                            display: flex;
                            .handle_icon {
                                display: block;
                            }
                        }
                    }
                }
                .chapter_task_content_box {
                    cursor: pointer;
                    .chapter_task_item_box {
                        .chapter_item_left_box {
                            .arrows_icon {
                                display: inline-block;
                                background-image: url('../../../common/images/cms/fewer.png');
                                background-size: 100% 100%;
                                width: 14px;
                                height: 8px;
                                margin-right: 20px;
                                transition: transform .3s,
                                -webkit-transform .3s;
                            }
                            .arrows_icon.is-active {
                                -webkit-transform: rotate(-180deg);
                                transform: rotate(-180deg);
                            }
                            .tackname {
                                margin-left: 34px;
                            }
                        }
                        &>div:nth-of-type(1){
                            background-color: #FFF;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 20px;
                            padding-left: 30px;
                            height: 56px;
                            &>div:nth-of-type(1){
                                color: #303133;
                            }
                            &>div:nth-of-type(2) {
                                display: flex;
                                .handle_icon {
                                    background-image: url('../../../common/images/cms/drag.png');
                                    background-size: 24px 24px;
                                    width: 24px;
                                    height: 24px;
                                    cursor: pointer;
                                    display: none;
                                }
                                .handle_icon:nth-of-type(1) {
                                    background-image: url('../../../common/images/cms/add.png');
                                }
                                .handle_icon:nth-of-type(1):hover {
                                    background-image: url('../../../common/images/cms/add_hover.png');
                                }
                                .handle_icon:hover {
                                    background-image: url('../../../common/images/cms/drag_hover.png');
                                }
                                .handle_icon:hover {
                                    background-image: url('../../../common/images/cms/drag_hover.png');
                                }
                                .handle_icon:nth-of-type(3){
                                    background-image: url('../../../common/images/cms/edit.png');
                                }
                                .handle_icon:nth-of-type(3):hover{
                                    background-image: url('../../../common/images/cms/edit_hover.png');
                                }
                                .handle_icon:nth-of-type(4){
                                    background-image: url('../../../common/images/cms/del.png');
                                }
                                .handle_icon:nth-of-type(4):hover{
                                    background-image: url('../../../common/images/cms/del_hover.png');
                                }
                                .handle_icon+.handle_icon {
                                    margin-left: 30px;
                                }
                            }
                        }
                        &>div:nth-of-type(2){
                            background-color: #E7EAEE;
                            padding: 30px 64px;
                            border-bottom: #F5F7FA solid 1px;
                            .showTips {
                                input {
                                    border-color: #FB6161;
                                }
                            }
                            &>div {
                                display: flex;
                                align-items: center;
                                .label_text {
                                    width: 84px;
                                }
                                .goods_info_box {
                                    background-color: #FFF;
                                    height: 50px;
                                    margin: 20px 0;
                                    padding: 0px 20px 0px 10px;
                                    display: flex;
                                    align-items: center;
                                    &>img{
                                        width: 46px;
                                        height: 26px;
                                        margin-right: 12px;
                                    }
                                    &>p{
                                        max-width: 280px;
                                        min-width: 240px;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        word-break: break-all;
                                    }
                                    &>span{
                                        color: #606266;
                                        // margin: 0 40px;
                                    }
                                    .select {
                                        width: 86px;
                                        min-width: 86px;
                                        margin-right: 10px;
                                    }
                                    .delete {
                                        width: 52px;
                                        min-width: 52px;
                                    }
                                }
                            }
                        }
                    }
                    .chapter_task_item_box:hover {
                        &>div:nth-of-type(1){
                            background-color: #F5F7FA;
                            &>div:nth-of-type(2) {
                                .handle_icon {
                                    display: block;
                                }
                            }
                        }
                    }
                    .chapter_task_item_box_content_box {
                        .chapter_task_item_box_content_box_item {
                            padding-left: 92px;
                            line-height: 56px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            background: #fff;
                            .taskname {
                                color: #303133;
                            }
                            .icon_box {
                                display: flex;
                                padding-right: 20px;
                                // align-items: center;
                                // height: 56px;
                                // width: 132px;
                                .handle_icon {
                                    background-image: url('../../../common/images/cms/drag.png');
                                    background-size: 24px 24px;
                                    width: 24px;
                                    height: 24px;
                                    cursor: pointer;
                                    display: none;
                                }
                                .handle_icon:hover {
                                    background-image: url('../../../common/images/cms/drag_hover.png');
                                }
                                .handle_icon:hover {
                                    background-image: url('../../../common/images/cms/drag_hover.png');
                                }
                                .handle_icon:nth-of-type(2){
                                    background-image: url('../../../common/images/cms/edit.png');
                                }
                                .handle_icon:nth-of-type(2):hover{
                                    background-image: url('../../../common/images/cms/edit_hover.png');
                                }
                                .handle_icon:nth-of-type(3){
                                    background-image: url('../../../common/images/cms/del.png');
                                }
                                .handle_icon:nth-of-type(3):hover{
                                    background-image: url('../../../common/images/cms/del_hover.png');
                                }
                                .handle_icon+.handle_icon {
                                    margin-left: 30px;
                                }
                            }
                            &:hover {
                                background: #F5F7FA;
                                .icon_box {
                                    .handle_icon {
                                        display: block;
                                    }
                                }
                            }
                        }
                        .taskEdit {
                            &:not(:first-of-type) {
                                margin-top: 1px;
                            }
                            padding: 20px 92px;
                            background: #EAEEF4;
                            .taskEdit_item_name {
                                margin-bottom: 20px;
                                .label_text {
                                    margin-right: 28px;
                                }
                            }
                            .test_paper {
                                display: flex;
                                align-items: center;
                                .goods_info_box {
                                    margin-left: 28px;
                                    border-radius: 4px;
                                    padding: 12px;
                                    background: #fff;
                                    display: flex;
                                    align-items: center;
                                    img {
                                        width: 46px;
                                        height: 26px;
                                        margin-right: 12px;
                                    }
                                    p {
                                        max-width: 300px;
                                        min-width: 300px;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        word-break: break-all;
                                    }
                                    span{
                                        color: #606266;
                                        // margin: 0 40px;
                                    }
                                    .select {
                                        min-width: 85px;
                                        width: 85px;
                                    }
                                    .delete {
                                        min-width: 52px;
                                        width: 52px;
                                    }
                                }
                            }
                        }
                    }
                }
                .add_chapter_box {
                    margin-top: 0;
                    background-color: #FFF;
                    transition: transform .3s,
                    -webkit-transform .3s;
                }
                .add_chapter_box:hover {
                    background-color: #FFF;
                }
            }
            .chapter_item_content:nth-of-type(1){
                margin-top: 0;
            }
            .add_chapter_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                background-color: #F5F7FA;
                height: 56px;
                padding: 0 30px;
                margin-top: 10px;
                padding-left: 64px;
                span {
                    color: #409EFF;
                    cursor: pointer;
                }
                span:hover {
                    color: rgb(33, 139, 245);
                }
            }
            .add_chapter_box:hover {
                background-color: #EAEEF4;
            }
        }
        .submit_box {
            display: flex;
            justify-content: center;
            align-items: center;
            // position: absolute;
            // bottom: 0;
            // width: 97.6%;
            // max-width: 97.6%;
            .el-button+.el-button {
                margin-left: 32px;
            }
        }
    }
</style>
<style lang="scss" type="text/scss" scope>
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
    }
    .el-dialog {
        margin: 0!important;
    }
    .el-dialog .el-dialog__body {
        padding: 20px;
    }
</style>